module.exports = __webpack_public_path__ + "static/media/Logo.f73324d4.png";